import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    Menu,
    MenuItem,
    IconButton,
    Avatar,
    Typography,
    Pagination,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Swal from 'sweetalert2';
import { post_data, serverURL } from '../../api'; // Ensure serverURL is correctly imported
import { useNavigate } from 'react-router-dom';
import TableLoader from './TableLoader';
import EmptyPage from '../EmptyPage';
import { formatPrice, primaryColor } from '../../constant';
import { Toaster, toast } from 'react-hot-toast';
import OrderDetailModel from '../OrderDetailModel';
import ShippedModal from '../models/ShippedModal';

const useStyles = makeStyles({
    root: {
        '& .MuiTableCell-root': {
            borderBottom: 'none',
            padding: '7px 10px',
        },
        '& .MuiTableRow-root': {
            borderBottom: '1px solid gainsboro',
        },
    },
    stageButton: {
        padding: '4px 12px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: 'bold',
        '&.processing': {
            backgroundColor: '#e8f5e9',
            color: '#43a047',
        },
        '&.shipped': {
            backgroundColor: '#fff3e0',
            color: '#fb8c00',
        },
        '&.delivered': {
            backgroundColor: '#e3f2fd',
            color: '#1e88e5',
        },
        '&.cancelled': {
            backgroundColor: '#ffebee',
            color: '#e53935',
        },
        '&.true': {
            backgroundColor: '#e3f2fd',
            color: '#1e88e5',
        },
    },
});

const OrdersTable = ({ data, tableHeader, getAllOrders, setLoading, totalData, loading, currentPage, setCurrentPage, itemsPerPage, totalPages }) => {

    const classes = useStyles();
    const navigate = useNavigate();
    const [rowsData, setRowsData] = useState(data || []);
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentRow, setCurrentRow] = useState(null);
    const [openShippedModal, setOpenShippedModal] = useState(false);

    const [detailModelOpen, setDetailModelOpen] = useState(false)
    const [detailModelData, setDetailModelData] = useState({})
    const handleCheckboxToggle = (index) => {
        const updatedRows = [...rowsData];
        updatedRows[index].checked = !updatedRows[index].checked;
        setRowsData(updatedRows);
    };
    useEffect(() => {
        setRowsData(data)
    }, [data])

    const handleMenuOpen = (event, index) => {
        setAnchorEl(event.currentTarget);
        setCurrentRow(index);
    };

    // Close the options menu
    const handleMenuClose = (row) => {
        setAnchorEl(null);
        setCurrentRow(null);
    };

    const handleEdit = (row) => {
        setAnchorEl(null);
        setCurrentRow(null);
    };
    // Delete a product after confirmation


    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const startEntry = (currentPage - 1) * itemsPerPage + 1;
    const endEntry = Math.min(currentPage * itemsPerPage, totalData);


    return (
        <>
            <Toaster
                position="top-right"
                reverseOrder={false}
            />
            <TableContainer style={{ background: 'white', borderRadius: 5, border: '1px solid gainsboro' }}>
                <Table className={classes.root}>
                    <TableHead>
                        <TableRow>
                            {tableHeader?.map((item, idx) => (
                                <TableCell key={idx} style={{ borderRight: '1px solid gainsboro', padding: '16px 10px', }}>
                                    {item}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    {loading ?
                        <div>
                            <TableLoader />
                        </div>
                        :
                        <TableBody>
                            {
                                rowsData?.map((row, index) => {
                                    return (
                                        <>
                                            <TableRow key={index}>
                                                <TableCell style={{ borderRight: '1px solid gainsboro', textAlign: 'center', width: '5%' }}>{startEntry + index}</TableCell>
                                                <TableCell style={{ borderRight: '1px solid gainsboro', width: '15%' }}>{row?.userId?.name}</TableCell>
                                                <TableCell style={{ borderRight: '1px solid gainsboro', width: '15%' }}>{row?.userId?.email}</TableCell>
                                                <TableCell style={{ borderRight: '1px solid gainsboro', width: '15%' }}>{row?.productId?.map((item) => { return (<div style={{ marginBottom: '5px' }}>{item?.name}</div>) })}</TableCell>
                                                <TableCell style={{ borderRight: '1px solid gainsboro', width: '10%' }}>{row?.transactionNumber}</TableCell>
                                                <TableCell style={{ borderRight: '1px solid gainsboro', width: '10%' }}>{formatPrice(row?.amount)}</TableCell>
                                                <TableCell style={{ borderRight: '1px solid gainsboro', width: '15%' }}>{row?.shippingAddress?.city}</TableCell>
                                                <TableCell style={{ borderRight: '1px solid gainsboro', width: '10%' }}>
                                                    <Button
                                                        style={{ fontSize: 11, fontWeight: 500, borderRadius: 30 }}
                                                        className={`${classes.stageButton} ${row?.orderStatus?.toLowerCase()?.replace(' ', '')}`}
                                                    >
                                                        {row?.orderStatus || '-'}
                                                    </Button>
                                                </TableCell>
                                                {/* <TableCell style={{ borderRight: '1px solid gainsboro' }}>
                                                    <Button
                                                        style={{ fontSize: 11, fontWeight: 500 }}
                                                        className={`${classes.stageButton} ${row?.isActive ? 'true' : 'closedLost'}`}
                                                    >
                                                        {row?.isActive ? 'Active' : 'Inactive'}
                                                    </Button>
                                                </TableCell> */}

                                                <TableCell style={{ borderRight: '1px solid gainsboro' }}>
                                                    <IconButton
                                                        className={classes.moreIcon}
                                                        onClick={(event) => handleMenuOpen(event, index)}
                                                    >
                                                        <MoreVertIcon />
                                                    </IconButton>


                                                    <Menu
                                                        anchorEl={anchorEl}
                                                        open={Boolean(anchorEl) && currentRow === index}
                                                        onClose={handleMenuClose}
                                                    >
                                                        <MenuItem onClick={() => {
                                                            handleMenuClose()
                                                            setDetailModelOpen(true)
                                                            setDetailModelData(row)
                                                        }}>View Details</MenuItem>

                                                        <MenuItem onClick={() => {
                                                            handleMenuClose()
                                                            setOpenShippedModal(true)
                                                            setDetailModelData(row)
                                                        }}>Shipped Order</MenuItem>
                                                    </Menu>
                                                </TableCell>
                                            </TableRow>
                                        </>
                                    )
                                })
                            }
                        </TableBody>
                    }
                </Table>

                {data?.length > 0 && (
                    <div
                        style={{
                            borderTop: "1px solid gainsboro",
                            padding: "2%",
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <Typography
                            style={{
                                fontWeight: 500,
                                fontSize: 15,
                                color: "black",
                            }}
                        >{`Showing ${startEntry} to ${endEntry} of ${totalData} Records`}</Typography>
                        <Pagination
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            color="primary"
                        />
                    </div>
                )}
                <OrderDetailModel open={detailModelOpen} setOpen={setDetailModelOpen} data={detailModelData} getAllOrders={getAllOrders} />
                <ShippedModal open={openShippedModal} setOpen={setOpenShippedModal} data={detailModelData} getAllOrders={getAllOrders} />
            </TableContainer>
        </>
    );
};

export default OrdersTable;
